/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Field } from 'formik';
import {
  Modal,
  Button,
  Box,
  CircularProgress,
  TextField,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import DecimalNumberField from '../../components/DecimalNumber';
import { ValidateWriteoffManualPayment } from '../../assets/validation';
import PaymentAction from '../../store/actions/PaymentAction';

function ManualPayment({ itemId, openmodal, modalstatus, onCloseModal }) {
  const dispatch = useDispatch();

  const title = modalstatus === 'manual' ? 'Manual Payment' : 'Write Off Payment';

  return (
    <Modal
      className="cmn__form__modal"
      open={openmodal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box>
        <Formik
          initialValues={{
            payment_gateway: '',
            transaction_id: '',
            amount: '',
            message: ''
          }}
          // enableReinitialize
          validationSchema={ValidateWriteoffManualPayment}
          onSubmit={(values, { setErrors, setSubmitting }) => {
            dispatch(
              PaymentAction.addManualPayment(
                itemId,
                values,
                modalstatus,
                setErrors,
                setSubmitting,
                onCloseModal
              )
            );
          }}
        >
          {({
            errors,
            touched,
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            handleReset,
            isSubmitting,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
              <Card>
                <CardHeader
                  title={title}
                  action={
                    <IconButton
                      aria-label="settings"
                      onClick={() => {
                        onCloseModal();
                      }}
                    >
                      <Close />
                    </IconButton>
                  }
                />
                <CardContent>
                  <TextField
                    id="payment_gateway"
                    fullWidth
                    label="Payment Method"
                    name="payment_gateway"
                    // size="medium"
                    margin="normal"
                    placeholder="Enter Payment Method"
                    value={values.payment_gateway}
                    onChange={handleChange}
                    onBlur={(e) => {
                      handleBlur(e);
                      const val = (e.target.value || '').replace(/\s+/gi, ' ');
                      setFieldValue(e.target.name, val.trim());
                    }}
                    error={errors.payment_gateway && touched.payment_gateway}
                    helperText={
                      errors.payment_gateway && touched.payment_gateway && errors.payment_gateway
                    }
                    required={false}
                    InputLabelProps={{ required: true }}
                  />
                  <TextField
                    fullWidth
                    id="transaction_id"
                    name="transaction_id"
                    label="Transaction ID"
                    placeholder="Enter Transaction ID"
                    variant="outlined"
                    margin="normal"
                    value={values.transaction_id}
                    onChange={handleChange}
                    onBlur={(e) => {
                      handleBlur(e);
                      const val = (e.target.value || '').replace(/\s+/gi, '');
                      setFieldValue(e.target.name, val.trim());
                    }}
                    error={touched.transaction_id && Boolean(errors.transaction_id)}
                    helperText={touched.transaction_id && errors.transaction_id}
                    required={false}
                    InputLabelProps={{ required: true }}
                  />
                  <Field name="amount">
                    {({ field }) => (
                      <TextField
                        {...field}
                        label="Amount"
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        value={values.amount}
                        // inputProps={{
                        //   Inputcomponent: DecimalNumberField
                        // }}
                        InputProps={{
                          maxlength: 8,
                          inputComponent: DecimalNumberField
                        }}
                        onChange={(event) => {
                          field.onChange(event);
                        }}
                        error={touched.amount && Boolean(errors.amount)}
                        helperText={touched.amount && errors.amount}
                        required={false}
                        InputLabelProps={{ required: true }}
                      />
                    )}
                  </Field>
                  <TextField
                    fullWidth
                    id="message"
                    name="message"
                    label="Message"
                    placeholder="Enter Message"
                    multiline
                    rows={3}
                    variant="outlined"
                    margin="normal"
                    // inputProps={{
                    //   maxLength: 128
                    // }}
                    value={values.message}
                    onChange={handleChange}
                    onBlur={(e) => {
                      handleBlur(e);
                      const val = (e.target.value || '').replace(/\s+/gi, ' ');
                      setFieldValue(e.target.name, val.trim());
                    }}
                    error={touched.message && Boolean(errors.message)}
                    helperText={touched.message && errors.message}
                    required={false}
                    InputLabelProps={{ required: true }}
                  />
                </CardContent>
                <CardActions sx={{ justifyContent: 'center' }}>
                  <Button
                    type="submit"
                    className="save__btn"
                    variant="contained"
                    color="secondary"
                    // fullWidth
                    disabled={isSubmitting}
                    size="medium"
                  >
                    {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                  </Button>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="medium"
                    onClick={() => {
                      handleReset();
                    }}
                  >
                    Clear
                  </Button>
                </CardActions>
              </Card>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}
ManualPayment.propTypes = {
  modalstatus: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
  openmodal: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default ManualPayment;
